<template>
  <div>
    <PrimaryButton light dense shrink @click.native="openDialog">
      Edit
      <template v-slot:append:icon>
        <v-icon>mdi-pencil</v-icon>
      </template>
    </PrimaryButton>
    <EditLanguageDialog
      v-if="isOpen"
      :language="language"
      :isOpen="isOpen"
      @close="closeDialog"
    />
  </div>
</template>

<script>
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import EditLanguageDialog from "@/views/profile/QuestionsAndAnswers/steps/LanguagesAndSkills/Languages/dialogs/EditLanguageDialog";

export default {
  name: "EditLanguageAction",
  components: {
    PrimaryButton,
    EditLanguageDialog
  },
  data() {
    return {
      isOpen: false
    };
  },
  props: {
    language: Object
  },
  methods: {
    openDialog() {
      this.isOpen = true;
    },
    closeDialog() {
      this.isOpen = false;
    }
  }
};
</script>
